<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/12bP5K7/tc-custom/9781429938327.jpg?1731159882295" alt="This image is the cover for the book One Moment, One Morning"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">One Moment, One Morning
      </h1>
      <p class="bookDescription body article font2">
        <b>“A man’s sudden death touches off seismic shifts in the lives of three women . . . in this affecting weeper about friendship and family.” —<i>Publishers Weekly</i></b><br/><br/>The Brighton to London line. The 7:44 am train. Cars packed with commuters. One woman occupies her time observing the people around her. Opposite, a girl puts on her make-up. Across the aisle, a husband strokes his wife’s hand. Further along, another woman flicks through a glossy magazine. Then, abruptly, everything changes: a man collapses, the train is stopped, and an ambulance is called.<br/><br/>For at least three passengers on the 7:44 on that particular morning, life will never be the same again. There’s Lou, in an adjacent seat, who witnesses events first hand. Anna, who’s sitting further up the train, impatient to get to work. And Karen, the man’s wife.<br/><br/>Telling the story of the week following that fateful train journey, <i>One Moment, One Morning</i> is a stunning novel about love and loss, about family and—above all—friendship. A stark reminder that, sometimes, one moment is all it takes to shatter everything. Yet it also reminds us that somehow, despite it all, life can and does go on.<br/><br/><b>“A real page-turner, exploring the harrowing pain of loss and grief, family secrets and how a tragic event can force you to be honest about who you really are. You’ll want to inhale it in one breath.” —<i>Easy Living</i> (UK)</b><br/><br/><b>“Fans of women’s fiction dealing with friendship and overcoming loss will appreciate discovering a new author.” —<i>Library Journal</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sarah Rayner
      </h2>
      
      <p class="authorDescription body article"><P>Sarah Rayner was born in London and now lives in Brighton with her partner. She worked for many years as an advertising copywriter, and now writes fiction full time.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Macmillan
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?24267fdc